const getReleaseInfo = () => fetch('/release_info.json')
  .then((response) => {
    if (!response.ok) {
      throw new Error('Failed to fetch release_info.json');
    }
    return response.json();
  })
  .catch((error) => {
    console.warn('Could not load release_info.json:', error);
    return { release: 'unknown' };
  });
export default getReleaseInfo;
